// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Hobz","paramInput":"JobSimulator_paramInput__oPGo7","input":"JobSimulator_input__9--J6"};